import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * Local Environment Configuration
 * Azure AD Corporate Authentication only (for Microsoft employees/managers)
 */

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
    auth: {
        clientId: '93a90b18-ee1d-49f5-a934-c8f2cca5a2fc', // Azure AD app client ID
        authority: `https://login.microsoftonline.com/${aadTenantId}`,
        redirectUri: 'http://localhost:3000/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Corporate scopes for Microsoft employees
const corporateScopes = [
    'api://93a90b18-ee1d-49f5-a934-c8f2cca5a2fc/default'
];

// Function to get login request
export const getLoginRequest = (): RedirectRequest => {
    return { scopes: corporateScopes };
};

export const loginRequest: RedirectRequest = {
    scopes: corporateScopes,
};

// Development-specific settings
export const apiConfig = {
    baseUrl: 'https://onboarding-client-dev-ghhjdphbg7dvchcx.b01.azurefd.net',
    timeout: 30000,
};

export const appConfig = {
    enableDebugMode: true,
    enableAnalytics: false,
    logLevel: LogLevel.Verbose,
    applicationInsightsConnectionString: 'InstrumentationKey=0a4741af-88f0-4448-88dd-c62d4904d65f;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=034c0418-43c3-44cc-b079-cdce4d7d48af',
};
